const env = import.meta.env;

export const legal = {
  companyName:    env.VITE_LEGAL_COMPANY_NAME    ?? 'Wundr Space Ltd',
  companyNumber:  env.VITE_LEGAL_COMPANY_NUMBER  ?? '15698755',
  companyAddress: env.VITE_LEGAL_COMPANY_ADDRESS ?? 'Tramshed Tech, Palace, 156 High Street, Swansea, Wales, SA1 1NE',
  contactEmail:   env.VITE_LEGAL_CONTACT_EMAIL   ?? 'hello@wundr.space',
  privacyEmail:   env.VITE_LEGAL_PRIVACY_EMAIL   ?? 'privacy@wundr.space',

  effectiveDate:  env.VITE_LEGAL_EFFECTIVE_DATE  ?? '',
  privacyVersion: env.VITE_LEGAL_PRIVACY_VERSION ?? '',
  termsVersion:   env.VITE_LEGAL_TERMS_VERSION   ?? '',

  dataDeletionUrl: env.VITE_LEGAL_DATA_DELETION_URL ?? '',

  icoUrl: 'https://ico.org.uk',
} as const;

export type LegalConfig = typeof legal;
